<template>
    <div class="position-fixed start-0 top-0 bottom-0 end-0 d-flex flex-row align-items-center" style="z-index: 9999; background: rgba(0,0,0,.6);">
        <div class="d-flex flex-column align-items-center justify-content-between w-100">
            <div class="spinner-border" style="width: 5rem; height: 5rem;" aria-live="polite">
                <output class="sr-only">Loading...</output>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "LoadingScreen",
}
</script>